export default __webpack_public_path__ + "static/media/StartVideo.4d4091fb.mp4";